import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { FormArray } from '@angular/forms';
import { GetSupplierEhsResponseByCode, SetCurrentSupplierCode } from 'app/profile/store/app.actions';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import * as MasterDataActions from 'app/profile/store/actions/masterdata.action';
import * as MasterDataSelectors from "../../store/selectors/masterdata.selector";
import { combineLatest, Subscription, forkJoin } from 'rxjs';
import { TabPermissions,ContextVerbiage,EhsResponse, Permission, SupplierEhsResponsePropertyValue, OPERATION, EHSProperty, EHSProperties } from 'app/profile/models/supplier.model';
import { SelectSupplierEhsResponse, SelectEventData,SelectPreventativeInProgress } from 'app/profile/store/app.selector';
import { template } from 'underscore';
import { TslDialog} from '@tesla/ng-tds';
import { MatDialog } from '@angular/material/dialog';
import { TabHistoryComponent } from '../tab-history/tab-history.component';
import { EhsEditComponent } from 'app/common/ehs/ehs-edit/ehs-edit.component';
import { FileUploadService } from 'app/common/services/fileUpload.service';
import { OnboardingTab } from 'app/profile/models/onboarding.model';
import { PostEvent ,GetPreventativeInProgress} from 'app/profile/store/app.actions';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
  selector: 'ehs-questionnaire',
  templateUrl: './ehs-questionnaire.component.html',
  styleUrls: ['./ehs-questionnaire.component.scss']
})
export class EhsQuestionnaireComponent implements OnInit {
  supplierCode: string;
  formData: any;
  formSchema: any;
  enableSubmit: boolean = false;
  version: number = 4;
  contextVerbiage: ContextVerbiage;
  responseData = new EhsResponse();
  editPermission: boolean = false;
  dynamicFormArray: FormArray;
  preventativeHold: boolean =false;
  supplierEhsResponse: SupplierEhsResponsePropertyValue[];
  @ViewChild('ehsEdit') ehsEditComponent: EhsEditComponent;
  onboardingTab: OnboardingTab = OnboardingTab.EHS;
  constructor(private store: Store<SupplierState>,
    private activatedRoute: ActivatedRoute,
    private dialog: TslDialog,
    private fileUploadService: FileUploadService,
    private matDialog: MatDialog,
    public translate: I18nService) {
    this.activatedRoute.parent.params.subscribe(params => {
      this.supplierCode = params['code'];
      this.store.dispatch(SetCurrentSupplierCode({ supplierCode: this.supplierCode }));
    });
  }

  ngOnInit(): void {
    this.store.dispatch(new GetSupplierEhsResponseByCode(this.supplierCode, true));
    this.store.select(MasterDataSelectors.SelectContextVerbiage).subscribe(contextVerbiage => this.contextVerbiage = contextVerbiage);
    this.store.dispatch(new MasterDataActions.GetFormTemplate(this.version, 'EHS'));

    combineLatest([this.store.select(MasterDataSelectors.SelectFormTemplate), this.store.select(SelectSupplierEhsResponse)])
      .subscribe(([template, supplierResponse]) => {
        if (template && template.formJson) {
          var formInfo = JSON.parse(template.formJson);
          formInfo["formAction"] = [];
          this.setReadOnly(formInfo["formBody"][0]["fields"]);
          this.formSchema = formInfo;
          this.responseData.TemplateId = template.id;
          this.responseData.Version = template.version;

          if (supplierResponse && supplierResponse.length > 0) {
            var response = supplierResponse[0].response.newValue;;
            this.formData = JSON.parse(response);
            var ehsInfo = supplierResponse[0];
            if (ehsInfo.response.permission == Permission.ReadWrite) {
              this.editPermission = true;
            }
          }
        }
      });
      if (this.supplierCode) { 
        this.store.dispatch(new GetPreventativeInProgress(this.supplierCode,true));
      this.store.pipe(select(SelectPreventativeInProgress)).subscribe(x => {
        if (x) {
          this.preventativeHold = x;
        }
      });
      }
  }

  setReadOnly(fields: any[]) {
    if (fields && fields.length > 0) {
      fields.forEach(x => { x["isReadonly"] = true });
    }
  }

  isDirty(): boolean {
    return false;
  }
  showHistory() {
    const dialogRef = this.matDialog.open(TabHistoryComponent, {
      width: '90%',
      minWidth: '630px',
      maxHeight: '800px',
      data: { supplierCode: this.supplierCode, tabName: 'EHS' }
    });
  }

  onSubmitClick() {
    const { updatedData, updatedSchema } = this.onFormDataChange();
    this.formData = updatedData.formData;
    this.dynamicFormArray = updatedSchema;
    this.submit(this.formData);
  }

  submit(data:any) {
    // Use touch functionality to display invalid fields
    this.ehsEditComponent?.dynamicFormComponent?.dynamicFormGroup?.markAllAsTouched();

    if (data) {
      data["title"] = "Environment, Health, and Safety (EHS) Questionnaire";
      data["subtitle"] = "Please supply the following information on behalf of the entity performing the work. This questionnaire helps the Tesla Contractor EHS Management team understand your company’s performance history. All subcontracted companies are also required to complete this questionnaire."

      this.processDocuments(data);
    }
  }

  processDocuments(data: any) {
    var fileData = [];
    for (var key in data) {
      if (key.includes('document')) {
        // filter/collect all documents to an array
        if (data[key] && data[key].length > 0) {
          data[key].forEach(x => {
            if (x && !x.documentId) {
              x.key = key;
              fileData.push(x);
            }
          });
        }
      }
    }
    this.uploadDocuments(fileData, data);
  }

  uploadDocuments(fileData: any[], data: any) {
    if (fileData && fileData.length > 0) {
      const filesUpload = fileData.map(file => this.fileUploadService.uploadFileToServer([file?.file], this.supplierCode).map(uploadedFile => {
        return {
          fileName: uploadedFile.fileName,
          documentId: uploadedFile.documentID,
          key: file.key
        }
      }));
      forkJoin(filesUpload).subscribe(info => { this.mapFileDataToResponse(info, data) })
    }
    else
    {
      this.submitResponse(data);
    }
  }

  mapFileDataToResponse(fileData: any[], response: any) {
    // replace the document object of the response with uploaded details.
    fileData.forEach(file => {
      if (response[file.key] && response[file.key].length > 0) {
        var index = response[file.key].findIndex(x => x.fileName.toLowerCase() === file.fileName.toLowerCase())
        if (index > -1) {
          var key = file.key;
          response[key][index] = file;
        }
        if (response[file.key].length > 1 && response[file.key].filter(x => x.fileName.toLowerCase() == file.fileName.toLowerCase()).length > 1
        && response[file.key].filter(x => x.fileName.toLowerCase() == file.fileName.toLowerCase() && x.documentId==undefined).length > 0) {
          var extraIndex= response[file.key].findIndex(x => x.fileName.toLowerCase() === file.fileName.toLowerCase() && x.documentId==undefined)
          response[file.key].splice(extraIndex, 1);
        }
      }
    });
    this.submitResponse(response);
  }

  submitResponse(responsedata: any) {
    let properties: EHSProperties = {
      EhsResponse: []
    };
    const response: string = JSON.stringify(responsedata);
    if (this.supplierEhsResponse[0].id.newValue) {
      const newProperty: EHSProperty = {
        ID: this.supplierEhsResponse[0].id.newValue,
        Operation: OPERATION.UPDATE,
        Response: response,
        TemplateId: this.supplierEhsResponse[0].templateId.newValue,
        Version: this.supplierEhsResponse[0].version.newValue
    };
    properties.EhsResponse.push(newProperty);
    }
    if (this.formSchema?.formBody && this.dynamicFormArray) {
      if (this.dynamicFormArray.status == "INVALID") {
        this.dialog.alert(this.translate.get('Alert'), this.translate.get('Please complete all fields to maintain accurate data for your organization.'));
      }
      else { 
        const dialogRef = this.dialog.confirm(this.translate.get('Confirm Submission'), this.translate.get('Are you sure you want to submit your changes?'), this.translate.get('Yes'), this.translate.get('No'));
        dialogRef.afterClosed().subscribe(result => {
          if (result == true) {
            this.processEHSchanges(properties);
          }
        });
      }
    }
  }
  processEHSchanges(ehsResponse:any){ 
    this.store.dispatch(new PostEvent({
      Name: 'EHS Change Requested',
      Properties: ehsResponse,
      ReferenceIdentifier: this.supplierCode
    }));
    this.store.select(SelectEventData).subscribe((evt: any) => {
      if (evt) {
        this.store.dispatch(new GetSupplierEhsResponseByCode(this.supplierCode, true));
        this.store.select(MasterDataSelectors.SelectContextVerbiage).subscribe(contextVerbiage => this.contextVerbiage = contextVerbiage);
        this.store.dispatch(new MasterDataActions.GetFormTemplate(this.version, 'EHS'));

        combineLatest([this.store.select(MasterDataSelectors.SelectFormTemplate), this.store.select(SelectSupplierEhsResponse)])
          .subscribe(([template, supplierResponse]) => {
            if (template && template.formJson) {
              var formInfo = JSON.parse(template.formJson);
              formInfo["formAction"] = [];
              this.setReadOnly(formInfo["formBody"][0]["fields"]);
              this.formSchema = formInfo;
              this.responseData.TemplateId = template.id;
              this.responseData.Version = template.version;
              if (supplierResponse && supplierResponse.length > 0) {
                var response = supplierResponse[0].response.newValue;;
                this.formData = JSON.parse(response);
              }
            }
          });
      }
    });    
  }
  allowEdit() { 
    combineLatest([this.store.select(MasterDataSelectors.SelectFormTemplate), this.store.select(SelectSupplierEhsResponse)])
    .subscribe(([template, supplierResponse]) => {
      if (template && template.formJson) {
        var formInfo = JSON.parse(template.formJson);
        if (supplierResponse && supplierResponse.length > 0) { 
          this.supplierEhsResponse = supplierResponse;
          var ehsInfo = this.supplierEhsResponse[0];
          if (ehsInfo.response.newValue) {
            this.formData = JSON.parse(ehsInfo.response.newValue);
          }
          if (ehsInfo.response.permission == Permission.ReadWrite) {
            formInfo["formAction"] = [];
            this.formSchema = formInfo;
            this.enableSubmit = true;
          }
          else {
            formInfo["formAction"] = [];
            this.setReadOnly(formInfo["formBody"][0]["fields"]);
            this.formSchema = formInfo;
            this.enableSubmit = false;
          }
        }

        if (supplierResponse && supplierResponse.length > 0) {
          var response = supplierResponse[0].response.newValue;;
          this.formData = JSON.parse(response);
        }
      }
    });
  }

  cancel()
  {
    combineLatest([this.store.select(MasterDataSelectors.SelectFormTemplate), this.store.select(SelectSupplierEhsResponse)])
    .subscribe(([template, supplierResponse]) => {
      if (template && template.formJson) {
        var formInfo = JSON.parse(template.formJson);
        formInfo["formAction"] = [];
        this.setReadOnly(formInfo["formBody"][0]["fields"]);
        this.enableSubmit = false;
        this.formSchema = formInfo;
        this.responseData.TemplateId = template.id;
        this.responseData.Version = template.version;
        if (supplierResponse && supplierResponse.length > 0) {
          var response = supplierResponse[0].response.newValue;;
          this.formData = JSON.parse(response);
        }
      }
    });
  }

  onFormDataChange() {
    const { updatedData ,updatedSchema} = this.ehsEditComponent.getUpdatedForm();
    return {
      updatedData: updatedData,
      updatedSchema: updatedSchema
  };
  }
}
